// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { frTranslations } from './locales/frDict';
import { enTranslations } from './locales/enDict';

const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie']
    }
  });

export default i18n;

/**
 * Translates an English text string into French if language is French and a translation exists.
 * Otherwise returns the English original text string.
 */
export function translateText(text, lng = i18n.language) {
  if (!text || typeof text !== 'string') return text;
  const currentLang = lng ? lng.split('-')[0].toLowerCase() : 'en';
  if (currentLang === 'fr') {
    return frTranslations[text] || text;
  }
  return text;
}
